import React from 'react';
import {useNavigate} from "react-router-dom";
import {Tabs} from "antd";

const MenuButtons = ({buttons}) => {
    const navigate = useNavigate();

    return (
        <div style={{padding: '10px 0'}}>
            <Tabs
                onChange={(key) => navigate(key)}
                type="card"
                items={buttons.map((button) => {
                    return {
                        label: button.label,
                        key: button.path,
                    };
                })}
                activeKey={window.location.pathname}
            />
        </div>
    );
};

export default MenuButtons;